import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const WebPortalDevelopmentPage: React.FC = () => {
  return <ServicePageTemplate slug="web-portal-development" />;
};

export default WebPortalDevelopmentPage;
